<div class="background-solid container" id="info">

  <section class="about">

    <div class="picture">
      <div class="img">
        <img src="assets/profile/profile-coube.JPG">
      </div>
    </div>

    <div class="text">
      <div><h1>SOBRE MIM</h1></div>
      <div>
        <p>Movido pela tecnologia, estou no meu último semestre do curso de Engenharia Elétrica pela Universidade
          Federal do Paraná.
          <br>
          <br>
          Há 2 anos entrei no mundo do desenvolvimento através de um estágio e
          permaneci nesse meio desde então.
          <br>
          Obtive muita experiência na área de desenvolvimento e gestão desde o início do meu estágio,
          depois de passar pela efetivação ao fim do estágio surgiram novos desafios e aprendizados.
          <br>
          <br>
          Inicialmente trabalhei com banco de dados sequencial, em seguida fui para o desenvolvimento front-end (e em alguns momentos back-end) e por fim me tornei Tech Lead de 3 squads.
          <br>
          <br>
          Agora estou me abrindo para novas experiências na área de desenvolvimento e liderança.
        </p>
      </div>
    </div>

  </section>

  <app-down-arrow></app-down-arrow>

</div>
